module.exports = "<p-toast [style]=\"{marginTop: '80px'}\"></p-toast>\n<router-outlet></router-outlet>"